'use client'

import { useReportError } from '@/lib/sentry/use-report-error'

// Catches errors thrown by the root layout itself, which app/error.tsx cannot.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useReportError(error)

  return (
    <html lang="en">
      <body>
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif', padding: 16 }}>
          <div style={{ textAlign: 'center', maxWidth: 420 }}>
            <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 16 }}>Something went wrong</h2>
            <p style={{ color: '#4b5563', marginBottom: 24 }}>Please refresh the page, or try again in a moment.</p>
            <a href="/" style={{ padding: '12px 24px', border: '1px solid #d1d5db', borderRadius: 8, color: '#374151', textDecoration: 'none', fontWeight: 600 }}>Go home</a>
          </div>
        </div>
      </body>
    </html>
  )
}
